import handleInputChange from '../function/HandleInputsChange';
import { UnitConversion } from '../inputs/UnitConversion';

const parseModel = (model) => {
  if (typeof model !== 'string')
    return { platform: '', beltRaw: null, centerlineRaw: null };

  if (model.startsWith('SV-L-')) {
    const [, , beltRaw, centerlineRaw] = model.split('-');
    return { platform: 'SV-L', beltRaw, centerlineRaw };
  }

  const [platform, beltRaw, centerlineRaw] = model.split('-');
  return { platform, beltRaw, centerlineRaw };
};

function ModelComponent({ optionChoice, setOptions, inputs, setInputs }) {
  const system = inputs.unit_system;

  const handleSelect = (value) => {
    handleInputChange('machine_type', value, inputs, setInputs, setOptions);
  };

  const round2 = (v) => (typeof v === 'number' ? Math.round(v * 100) / 100 : v);

  const columns = [
    { key: 'model', label: 'Model' },
    { key: 'platform', label: 'Platform' },
    { key: 'belt', label: 'Belt width', unit: 'mm' },
    { key: 'centerline', label: 'Centerline diameter', unit: 'mm' },
  ];

  return (
    <div className="glass model-container">
      <table>
        <thead>
          <tr>
            {columns.map(({ key, label, unit }) => {
              const { displayedUnit } = unit
                ? UnitConversion(null, system, unit)
                : {};

              return (
                <th key={key}>
                  {label}
                  {displayedUnit ? ` [${displayedUnit}]` : ''}
                </th>
              );
            })}
            <th />
          </tr>
        </thead>

        <tbody>
          {optionChoice?.sort().map((model, index) => {
            const { platform, beltRaw, centerlineRaw } = parseModel(model);

            const belt = UnitConversion(beltRaw, system, 'mm');
            const centerline = UnitConversion(centerlineRaw, system, 'mm');

            return (
              <tr
                key={model}
                className={inputs.machine_type === model ? 'active' : ''}
                onClick={() => handleSelect(model)}
              >
                <td>{model}</td>
                <td>{platform}</td>
                <td>{round2(belt.displayedValue)}</td>
                <td>{round2(centerline.displayedValue)}</td>

                <td>
                  <input
                    type="radio"
                    checked={inputs.machine_type === model}
                    onChange={() => handleSelect(model)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ModelComponent;
